import { render, staticRenderFns } from "./VerOrdenVenta.vue?vue&type=template&id=b8aa5720&scoped=true&"
import script from "./VerOrdenVenta.vue?vue&type=script&lang=js&"
export * from "./VerOrdenVenta.vue?vue&type=script&lang=js&"
import style0 from "./VerOrdenVenta.vue?vue&type=style&index=0&id=b8aa5720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aa5720",
  null
  
)

export default component.exports